import React from 'react';
import Button from './button';
import Card from './card';
import { GrowlActions } from '../actions';
import store from '../store';

class Growl extends React.Component {
    static get growlTypes() {
        return {
            POSITIVE: 'POSITIVE',
            WARNING: 'WARNING',
            ERROR: 'ERROR'
        }
    }

    delay() {
        store.dispatch(GrowlActions.delayGrowl(this.props.growlId));
    }

    render () {
        return (
            <Card {...this.props} onClick={() => this.delay()} className={['component-growl', this.props.className].join(' ')}>
                <div className="growl-text">{this.props.message}</div>
                <Button className="growl-action" onClick={() => store.dispatch(GrowlActions.removeGrowl(this.props.growlId))}>Dismiss</Button>
            </Card>
        )
    }
}

export default Growl;



// WEBPACK FOOTER //
// ./web-app/components/growl.jsx